import React, { useState } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ParametersSection } from './components/ParametersSection';
import { GallerySection } from './components/GallerySection';
import { LocationSection } from './components/LocationSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { GalleryPage } from './pages/GalleryPage';
export function App() {
  const [currentPage, setCurrentPage] = useState<'home' | 'gallery'>('home');
  const [galleryInitialIndex, setGalleryInitialIndex] = useState<number | undefined>(undefined);
  const handleNavigate = (page: string) => {
    if (page.startsWith('gallery:')) {
      const index = parseInt(page.split(':')[1], 10);
      setGalleryInitialIndex(index);
      setCurrentPage('gallery');
      window.scrollTo(0, 0);
    } else if (page === 'gallery') {
      setGalleryInitialIndex(undefined);
      setCurrentPage('gallery');
      window.scrollTo(0, 0);
    } else if (page === 'home') {
      setCurrentPage('home');
      window.scrollTo(0, 0);
    }
  };
  return <div className="min-h-screen bg-neutral-50 font-sans" data-id="element-0">
      <Navbar onNavigate={handleNavigate} currentPage={currentPage} data-id="element-1" />
      <main data-id="element-2">
        {currentPage === 'home' ? <>
            <HeroSection data-id="element-3" />
            <AboutSection onNavigate={handleNavigate} data-id="element-4" />
            <ParametersSection data-id="element-5" />
            <GallerySection onNavigate={handleNavigate} data-id="element-6" />
            <LocationSection data-id="element-7" />
            <ContactSection data-id="element-8" />
          </> : <GalleryPage onNavigate={handleNavigate} initialIndex={galleryInitialIndex} data-id="element-9" />}
      </main>
      <Footer onNavigate={handleNavigate} data-id="element-10" />
    </div>;
}